import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromPages from '../reducers/pages.reducer';
import * as fromRoot from '../../../store';
import { getRouterState } from '../../../store';

// tslint:disable-next-line:max-line-length
export const getPageState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.pages);

export const getPageEntities = createSelector(getPageState, fromPages.getPagesEntities);

export const getAllPages = createSelector(getPageEntities, entities => {
  return Object.keys(entities).map(handle => entities[handle as unknown as number]);
});
export const getPagesLoaded = createSelector(getPageState, fromPages.getPagesLoaded);
export const getPagesLoading = createSelector(getPageState, fromPages.getPagesLoading);

export const getSelectedPage = createSelector(getAllPages, fromRoot.getRouterState, (Pages, router) => {
  return router.state && Pages?.find(a => a.handle === router.state.params['pageHandle']);
});
